<template>
  <div class="container">
    <h2 id="soils">4. Soils</h2>
    <div class="row">
      <div class="col-sm-12">
        <p>
          The Soilgrids dataset by ISRIC contains global predictions of various physical and chemical soil properties at around 300m resolution [<a href="#ref-5">5</a>]. By combining data on actual measurements with prediction algorithms, soil parameters can be predicted in an area based on measurements that have been done in similar conditions.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">

        <h3>4.1 Texture</h3>
        <p>
          Texture is an imporant soil parameter and refers to the proportion of sand, silt, and clay sized particles in the soil. Sand particles are the largest (above 0.05mm), then silt (from 0.05 to 0.002mm), and clay particles are the smallest (smaller than 0.002mm). The way in which these three proportions are combined defines the texture of the soil. Soil texture can be indicative of the amount of water the soil can hold, how fast water can move through it, and how workable and fertile the soil is.
        </p>

        <p v-if="loaded">
          In the area of interest, soil textures of
          <span v-for="(item, index) in soilTextureClassList" v-bind:item="item" :key="item.description">
            <span v-if="(index == (soilTextureClassList.length-1)) && (soilTextureClassList.length>1)">
              and 
            </span>
            <strong>{{item.description.toLowerCase()}} ({{item.percent.toFixed(1)}}%)</strong>
            <span v-if="index != (soilTextureClassList.length-1)">, </span>
          </span>
        </strong>
          are predicted.
        </p>

      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-lg-9 col-md-12 col-sm-12">
        <table class='table table-sm' style="font-size:0.9em;" v-if="loaded">
          
        </table>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-lg-12">
        <RasterMap 
          backgrounds="streets,satellite,light,osm" 
          title="Soil Property Predictions" 
          description="Soil Texture Predictions" 
          attribution="Map: Geofolio. Data: ISRIC SoilGrids [5]. Backgrounds: Mapbox/Openstreetmap Contributors [13]." 
          v-bind:layout="{legendWidth:6, legendCols:2, descriptionWidth:6 }"
          v-bind:location="location"
          v-bind:factsheet="factsheet" 
          v-bind:loaded="loaded" 
          v-bind:layers="layers">
        </RasterMap>
      </div>
    </div>

    <div class="row">
      <div class="col">
        
      </div>
    </div>
  </div>
</template>


<script>
import "leaflet/dist/leaflet.css";
import _ from 'lodash';
import RasterMap from '@/components/factsheet/RasterMap.vue'

export default {
    name: 'Soils',
    components:{
        RasterMap
    },
    props: ['location', 'factsheet', 'loaded'],
    data() {
        return {
          'layers': [
            {'title': 'Texture', 'source': '/soilgrids_texture/texture-0cm.tif', 'long_description': "<p>The soil texture layer shows predicted USDA soil texture classes at 0cm depth. The classification is made by mapping predicted sand, silt, and loam fractions to a texture using the SDA soil texture classification triangle.</p>" },
            {'title': 'Bulk Density', 'source': '/soilgrids_other/soil_bulk_density.tif', 'long_description': "<p>The soil bulk density layer is an indicator of soil compaction is calculated as the dry weight of the soil divided by its volume. The bulk density predictions are shown in 10 x kg/m<sup></sup>.</p>" },
            {'title': 'Classification', 'source': '/soilgrids_other/soilgrids_MostProbable.tif', 'long_description': "<p>The soil classification layer shows the most probable soil group classification according to the <a href='https://www.isric.org/explore/wrb' target='_blank'>World Reference Base Soil Groups</a>.</p>" }
          ]
        }
    },
    created() {

    },
    computed: {
        soilTextureClassList: function() {
            var filtered = _.filter(this.factsheet.data.soilgrids_texture.classification, ({percent}) => percent > 1)
            return _.orderBy(filtered, function(p) { return p.percent }, ['desc'])
        }
    },
    mounted() {
    }
}
</script>

<style>

</style>